import { defineMessages } from "react-intl";

const PREFIX = "RegisterPage";
export default defineMessages({
  header: {
    id: `${PREFIX}.header`,
    defaultMessage: "Sign up",
  },
  registerButton: {
    id: `${PREFIX}.register`,
    defaultMessage: "Register",
  },
  loginButton: {
    id: `${PREFIX}.loginButton`,
    defaultMessage: "Log In",
  },
  errorMessage: {
    id: `${PREFIX}.errorMessage`,
    defaultMessage: "Please, check the correctness of the entered data",
  },
  login: {
    id: `${PREFIX}.login`,
    defaultMessage: "E-mail",
  },
  password: {
    id: `${PREFIX}.password`,
    defaultMessage: "Password",
  },
  name: {
    id: `${PREFIX}.name`,
    defaultMessage: "Name",
  },
  surname: {
    id: `${PREFIX}.surname`,
    defaultMessage: "Surname",
  },
  department: {
    id: `${PREFIX}.department`,
    defaultMessage: "Department",
  },
  confirmPassword: {
    id: `${PREFIX}.confirmPassword`,
    defaultMessage: "Confirm Password",
  },
  fieldIsRequired: {
    id: `${PREFIX}.fieldIsRequired`,
    defaultMessage: "The field is required",
  },
  emailNotInSystem: {
    id: `${PREFIX}.emailNotInSystem`,
    defaultMessage: "Sorry, this email can not be registered in the system.",
  },
  passwordsMustMatch: {
    id: `${PREFIX}.passwordsMustMatch`,
    defaultMessage: "New password and its confirmation must match",
  },
  checkCorrectness: {
    id: `${PREFIX}.checkCorrectness`,
    defaultMessage: "Please, check the correctness of the entered data",
  },
  passwordLengthError: {
    id: `${PREFIX}.passwordLengthError`,
    defaultMessage:
      "The password must contain at least eight characters, lowercase and uppercase letters, numbers, and special characters",
  },
  emailExists: {
    id: `${PREFIX}.emailExists`,
    defaultMessage: "The e-mail is already registered",
  },
});
